import React from "react";
import {Translate} from "react-localize-redux";
import "./NoMatchView.scss";
import {Button} from "antd";

const NoMatchView: React.FC = (): React.ReactElement => {
    const translatePath: string = "pages.NoMatchView.NoMatchView";

    return (
        <div className="df-404-view">
            <div className="df-404-content">
                <h2><Translate id={`${translatePath}.404.text`}/></h2>
                <p><Translate id={`${translatePath}.pageNotFound.text`}/></p>
                <p><Translate id={`${translatePath}.instruction.text`}/></p>
                <Button
                    type="primary"
                    onClick={(): void => window.history.back()}
                >
                    <Translate id={`${translatePath}.goBack.text`}/>
                </Button>
            </div>
        </div>

    );
};

export default NoMatchView;
